import React, { useRef } from "react";
import styled from "styled-components";
import { useAdsense } from "./useAdsense";

const DisplayAdsStatic = () => {
  const insRef = useRef(null);
  useAdsense(insRef);

  return (
    <Container>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5113702954144664"
        data-ad-slot="9562839257"
        data-ad-format="fluid"
        data-full-width-responsive="true"
      ></ins>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 10%;
  border: 1px solid var(--light-gray-200, #edeeef);
`;

export default DisplayAdsStatic;
